module.exports = __webpack_public_path__ + "static/media/cvadvice.3eccf249.webp";